/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import { responseMiddleware } from "../../../redux/reducers";
import { IsPermisionOidRequired } from "../../../redux/actions";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";
import OvertimeSummaryTableList from "./OvertimeSummaryTable";
export default function OvertimeSummaryList() {
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("OvertimeSummary")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/overtime-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Overtime")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("OvertimeSummary")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <OvertimeSummaryTableList
            middleware={middleware}
            dataGrid={dataGrid}
          />
        </div>
      </div>
    </div>
  );
}
